<template>
  <div>
    <el-drawer
      show-close
      direction="ltr"
      :visible.sync="drawerVisible"
      :with-header="false"
      size="60%"
      :before-close="beforeCloseDrawer"
    >
      <ul>
        <li>
          <p class="menu-txt" @click="goHome">
            <span> <i class="el-icon-s-home"></i>&nbsp;首页</span>
          </p>
        </li>

        <li v-if="getLoginUser == 'admin'">
          <p class="menu-txt" @click.stop="expandSettings">
            <span><i class="el-icon-s-tools"></i>&nbsp;设置</span>
            <i
              :class="expandSet ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
              @click.stop="expandSettings"
            ></i>
          </p>
          <p v-show="expandSet" class="subMenu-txt" @click="userSetting">
            <span><i class="el-icon-user-solid"></i>&nbsp;用户设置</span>
          </p>
        </li>

        <li>
          <p class="menu-txt" @click="quit">
            <span>
              <i class="quitIcon iconfont icon-tuichu"></i>
              &nbsp;退出登录
            </span>
          </p>
        </li>
      </ul>
      <p class="closeContainer menu-txt">
        <i class="closeIcon el-icon-circle-close" @click="closeDrawer"></i>
      </p>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: ['drawerVisible'],
  data () {
    return {
      getLoginUser: JSON.parse(localStorage.getItem('userInfo')).userName,
      expandSet: false
    }
  },
  methods: {
    closeDrawer () {
      this.$emit('closeDrawer')
    },
    beforeCloseDrawer () {
      this.$emit('closeDrawer')
    },
    goHome () {
      this.$emit('closeDrawer')
      this.$router.push('/home')
    },
    userSetting () {
      this.$emit('closeDrawer')
      this.$router.push('/userManagement')
    },
    expandSettings () {
      console.log('展开设置')
      this.expandSet = !this.expandSet
    },
    quit () {
      // 清除token
      sessionStorage.removeItem('access_token')
      this.$store.commit('CLEAR_TOKEN')
      // 跳转路由
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.quitIcon {
  font-size: 0.7em;
  font-weight: 700;
  margin-left: 20px;
  margin-right: -20px;
}
.menu-txt {
  font-size: 6em;
  padding: 1em;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.subMenu-txt {
  font-size: 5.2em;
  padding: 1em 3em;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.closeContainer {
  position: absolute;
  bottom: 300px;
  left: 50%;
  transform: translateX(-50%);
  .closeIcon {
    font-size: 1.6em;
  }
}
</style>
